import {
	AIFeaturesModel,
	FoundryModelCapability,
} from "src/types/aiFeaturesConfiguration";
import { AIFeaturesService as AIFeaturesConfigurationService } from "./aiFeaturesConfigurationService";

export interface ApiAiFeaturesConfigurationService {
	getAIFeatures(): Promise<any>;
	saveAIFeatures(data: AIFeaturesModel): Promise<any>;
	getAssistants(): Promise<any>;
	getAgents(): Promise<any>;
	getModels(capability: FoundryModelCapability): Promise<any>;
}

export const aiFeaturesConfigurationService = new AIFeaturesConfigurationService();
